module.exports = __webpack_public_path__ + "static/media/toolbar-pin.ddbc6968.svg";